import { Context, createContext, useContext } from 'react';

export interface IMobileHeaderContext {
    isMenuScrolling?: boolean,
}

export const MobileHeaderContext: Context<IMobileHeaderContext> =
    createContext<IMobileHeaderContext>({});

export const useMobileHeaderContext = () => {
    return useContext(MobileHeaderContext);
};
